/**
 * Firebase Auth UIDs allowed to view org-climate survey dashboards.
 * No admin bypass — only these three UIDs.
 * Must stay in sync with isOrgClimateSurveyViewer() in firestore.rules.
 */
export const ORG_CLIMATE_SURVEY_VIEWER_UIDS = [
  'FDbScvYwK9NguMvSOflJmVrysi12',
  'WJ4rSPmUaEaWCNewKZxFJ1sKqN52',
  'asOI8v3nkhUelS2Q1EK6VplbvY52',
] as const;

const VIEWER_UID_SET = new Set<string>(ORG_CLIMATE_SURVEY_VIEWER_UIDS);

export function isOrgClimateSurveyViewerUid(uid: string | null | undefined): boolean {
  if (uid == null || uid === '') return false;
  return VIEWER_UID_SET.has(uid.trim());
}

export function canViewOrgClimateSurveys(uid: string | null | undefined): boolean {
  return isOrgClimateSurveyViewerUid(uid);
}
